"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M32 26.956v-15h2.565a.431.431 0 0 0 .262-.724l-3.971-3.956a.5.5 0 0 0-.706 0l-3.963 3.954a.431.431 0 0 0 .262.724h2.565l.006 15a1 1 0 0 0 1 1h.993a.988.988 0 0 0 .987-.998z" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "12", x: "2", y: "8" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "16", x: "2", y: "16" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "20", x: "2", y: "24" })
);

